import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesDetailsModule } from './companies-details/companies-details.module';

// import { CompaniesDetailsIndicationComponent } from './indications/companies-details-indication.component';
// import { CompaniesDetailsInternalComponent } from './internal/companies-details-internal.component';
// import { SidebarInternalComponent } from './internal/sidebar/sidebar-internal.component';

@NgModule({
  declarations: [
    // CompaniesDetailsIndicationComponent,
    // CompaniesDetailsInternalComponent,
    // SidebarInternalComponent,
  ],
  imports: [
    CommonModule,
    CompaniesRoutingModule,
    CompaniesDetailsModule,
  ]
})
export class CompaniesModule { }
